const SectionTitle = ({title}) => {
  return (
    <h3 className="uppercase py-4 md:py-6 inline-block text-3xl md:text-5xl relative before:content-['']  before:absolute before:rounded-full before:w-3 before:h-3 before:bg-[#e60000] before:bottom-0 before:left-0
     after:content-[''] after:absolute after:w-[30%] after:h-1 after:left-0 after:bottom-1 after:bg-[#e60000]
    ">
      {title}
    </h3>
  );
};

export default SectionTitle;
